import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-loader',
  templateUrl: './mini-loader.component.html',
  styleUrls: ['./mini-loader.component.sass'],
})
export class MiniLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
